import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Home } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_712ba195-f8b2-4b91-a610-23f4aedf7ae0/artifacts/i0b4179m_A_I_Means_Business.jpg";

const ClientLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 glass">
        <nav className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/portal" className="flex items-center gap-3" data-testid="client-logo">
              <img src={LOGO_URL} alt="A.I. Means Business" className="h-10 w-auto bg-white rounded" />
              <span className="font-heading font-semibold text-white">Client Portal</span>
            </Link>

            <div className="flex items-center gap-4">
              <Link to="/" data-testid="client-home-link">
                <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-white">
                  <Home className="w-4 h-4 mr-2" />
                  Home
                </Button>
              </Link>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                  <span className="text-primary text-sm font-semibold">
                    {user?.name?.[0]?.toUpperCase() || "C"}
                  </span>
                </div>
                <span className="text-sm text-white hidden sm:block">{user?.name}</span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground hover:text-white"
                onClick={handleLogout}
                data-testid="client-logout-btn"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="pt-24 pb-12 px-6">
        <div className="max-w-5xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ClientLayout;
